module.exports = __webpack_public_path__ + "img/userLogo4.dc952243.jpg";